import { startTransition, type Dispatch } from 'react';

import { cn } from '@/utils/tailwind';

import { Button } from '@/components/atoms/NewPcButton';

interface FilterButtonProps {
  canOrderCount: number;
  receiverFilter: boolean;
  setReceiverFilter: Dispatch<React.SetStateAction<boolean>>;
  title: string;
}

const FilterButton = ({
  canOrderCount,
  title,
  receiverFilter,
  setReceiverFilter,
}: FilterButtonProps) => {
  return (
    <div className="flex w-[181px] items-center">
      <Button
        variant="line"
        size="small"
        onClick={() => startTransition(() => setReceiverFilter((prev) => !prev))}
        className={cn(
          'h-10 ',
          receiverFilter ? 'border-point-500  bg-white text-point-500' : 'bg-white text-gr-700',
        )}
      >
        {receiverFilter ? '전체 주문 보기' : `${title} ${canOrderCount}`}
      </Button>
    </div>
  );
};

export default FilterButton;
